import { render, staticRenderFns } from "./modifyLoginPwd.vue?vue&type=template&id=64a58c5a&scoped=true&"
import script from "./modifyLoginPwd.vue?vue&type=script&lang=js&"
export * from "./modifyLoginPwd.vue?vue&type=script&lang=js&"
import style0 from "./modifyLoginPwd.vue?vue&type=style&index=0&id=64a58c5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a58c5a",
  null
  
)

export default component.exports